import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import styles from "../css/Modal.module.css";

const Modal = ({
  title,
  children,
  onClose,
  showConfirm = true,
  onConfirm,
  confirmText,
  cancelText,
  isDelete,
  onDelete,
  bgOpacity = 0.8,
  modalBoxHeight = "90vh",
  textBoxMaxHeight = "70vh",
  extraButtons, // optional React nodes rendered in the actions row next to the cancel/confirm buttons
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const boxStyle =
    modalBoxHeight !== "90vh"
      ? { height: modalBoxHeight, maxHeight: modalBoxHeight }
      : {};
  const textBoxStyle =
    textBoxMaxHeight !== "70vh" ? { maxHeight: textBoxMaxHeight } : {};

  return (
    <div
      className={styles.container}
      style={{ "--bg-opacity": bgOpacity }}
      onClick={onClose}
    >
      <div
        className={styles.modal_box}
        style={boxStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.textBox} style={textBoxStyle}>
          <h2 className={styles.text}>{title}</h2>
          {children || <p>{t("modalConfirmChange.question")}</p>}
        </div>
        <div className={styles.btn_box}>
          <button className={`btn delete`} onClick={onClose}>
            {cancelText || t("modalConfirmChange.cancel")}
          </button>
          {extraButtons}
          {confirmText !== "" && showConfirm && (
            <button
              className={`btn`}
              onClick={(e) => {
                e.target.blur();
                onConfirm();
              }}
            >
              {confirmText || t("modalConfirmChange.accept")}
            </button>
          )}
          {isDelete && (
            <button
              className={`btn delete`}
              onClick={(e) => {
                e.target.blur();
                onDelete();
              }}
            >
              Vypnout
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
